import { SubscriptionHookOptions, useSubscription } from '@apollo/client';

import { JourneysDocument, JourneysSubscription, JourneysSubscriptionVariables } from '@typing/Generated';

type Journey = NonNullable<NonNullable<JourneysSubscription['journeys']>['journey']>;

type UpdateFunc = (journey: Journey) => void;

const useSubscribeToJourneys = (
  onUpdate?: UpdateFunc,
  options?: SubscriptionHookOptions<JourneysSubscription, JourneysSubscriptionVariables>
) => {
  useSubscription<JourneysSubscription, JourneysSubscriptionVariables>(JourneysDocument, {
    ...options,
    onData: data => {
      if (data.data.data?.journeys?.journey && onUpdate) {
        onUpdate(data.data.data.journeys.journey);
      }
    },
    variables: {}
  });
};

export default useSubscribeToJourneys;
